<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'
import SubscriptionMapModal from './modals/subscription_map_modal'

export default {
  page: {
    title: "Müşteri Listesi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [ datatableMixin ],
  components: {
    Layout,
    PageHeader,
    Datatable,
    SubscriptionMapModal
  },
  data() {
    return {
        title: "MÜŞTERİ LİSTESİ",
        items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "MÜŞTERİ LİSTESİ",
          active: true,
        },
      ],

      searchParams: {},
      columns: [
          { name: '', key: 'action', orderable: false },
          { name: 'Tipi', key: 'type', orderable: true},
          { name: 'Bayisi', key: 'user_name', orderable: true},
          { name: 'Apt. Sistemi', key: 'apartment_name', orderable: true},
          { name: 'Kullanıcı Adı', key: 'username', orderable: true},
          { name: 'İsim Soyisim', key: 'changedLabel', width: 150 , orderable: true},
          { name: 'Bitiş Tarihi', key: 'expiredate', className: 'text-end', orderable: true, width: 150  },
          { name: 'Cep Telefonu', key: 'phonenumber', className: 'text-end', width: 150  },
          { name: 'İl', key: 'province', className: 'text-end', width: 150},
          { name: 'Bölge', key: 'township', className: 'text-end',  width: 150  },
          { name: 'Adres', key: 'address', className: 'text-end',  width: 150  },
          { name: 'Servisi', key: 'tariff_name', className: 'text-end',  width: 150, orderable: true },
      ],
      tableData: {
        detail: true,
        excel: true,
        searchable:{
          visible:true,
          placeholder:"İsim Soyisim de Ara"
        }
      },
      endpoint: '/reports/bitis-tarihi',
      exportName: 'MUSTERI_LISTESI',
      isLoading: true,
      detailSearch:true,
      requestSeq: 0,
      form:{
        group:'',
        status:'',
        enddateend : '',
        enddate:'',
        startdate:'',
        startdateend:'',
        province:'',
        bolge:'',
        tariff:''
      },
      ilList: [],
      bucakList:[],
      tariffList: [],
      groupList: [],
      mapItems: [],
      mapLoading: false,
      excelList: [],
      excelLoading: false,
      excelCreating: false,
    };
  },
  mounted() {
    this.setSelected({ id : 0},'il')

    this.getTariff()
    this.getGroups()
    var currentURL = window.location.href;
    var params = new URLSearchParams(new URL(currentURL).search);
    var statusValue = params.get("status");

    this.form.status = statusValue

    this.searchParams = {status : statusValue}
    this.isLoading = false
    this.loadPage()
  },

  methods: {

    async loadPage(force = false) {

      if ((this.isLoading || this.pageLoading) && !force) return false

      const requestId = ++this.requestSeq
      const requestPage = this.params.page
      const payload = {
        params: { ...this.params },
        search_params: { ...this.searchParams },
        sort: { ...this.sort },
        search_query: this.searchQuery,
        searchTerm: this.searchQuery
      }

      requestPage === 1 ? this.isLoading = true : this.pageLoading = true

      try {
        const response = await this.$http.post(this.endpoint, payload);
        if (requestId !== this.requestSeq) return

        if (requestPage === 1) {
            this.tableData.data = response.data.data;
        } else {
            this.tableData.data = [...this.tableData.data, ...response.data.data];
        }

        this.tableData.pagination = { current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total };
      } finally {
        if (requestId === this.requestSeq) {
          requestPage === 1 ? this.isLoading = false : this.pageLoading = false
        }
      }
    },


    expiredate(expiredate){
      return this.formatDate(expiredate, "DD.MM.YYYY HH:mm")
    },



    getTariff(){
      this.$http.post('/tariff/getByGroup', { groupName : 'wifi' ,output:'only'})
        .then(response => this.tariffList = response.data.content )
    },

    getGroups(){
      this.$http.post('/groups')
        .then(response => this.groupList = response.data)
    },

    async setSelected(val,event){
        const object = event + 'List'
        const { id } = val
        const response = await this.$http.post(`/address/${event}/${id}`)

        if(response.data.error) return;
        this[object] = response.data;

        this.handleFilterChange()
    },



    yenile(props){
      location.href="/musteri-ara?username=" + props.username
    },

    reLoadPage(query) {
      this.requestSeq += 1
      this.searchQuery = query
      this.params.page = 1
      this.tableData.data = []
      this.tableData.pagination = { current_page: 1, last_page: 1, total: 0 }
      this.isLoading = false
      this.pageLoading = false
      this.loadPage(true)
    },

    excelExport() {
      this.$bvModal.show('musteri_excel_modal')
      this.loadExcelList()
    },

    async loadExcelList() {
      this.excelLoading = true
      try {
        const response = await this.$http.get('/reports/bitis-tarihi/excel')
        this.excelList = response.data.content || []
      } catch (err) {
        void err
        this.excelList = []
      } finally {
        this.excelLoading = false
      }
    },

    saveBlob(data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },

    async createExcel() {
      if (this.excelCreating) return
      this.excelCreating = true
      try {
        const response = await this.$http.post('/reports/bitis-tarihi/excel', {
          params: this.params,
          search_params: this.searchParams,
          sort: this.sort,
          search_query: this.searchQuery,
          searchTerm: this.searchQuery
        }, { responseType: 'blob' })
        this.saveBlob(response.data, `${this.exportName}.xlsx`)
        await this.loadExcelList()
      } finally {
        this.excelCreating = false
      }
    },

    async downloadExcel(row) {
      const response = await this.$http.get('/reports/bitis-tarihi/excel/' + row.id, { responseType: 'blob' })
      this.saveBlob(response.data, row.filename)
    },

    handleFilterChange() {
      this.requestSeq += 1
      this.searchParams = this.form
      this.params.page = 1
      this.tableData.data = []
      this.tableData.pagination = { current_page: 1, last_page: 1, total: 0 }
      this.isLoading = false
      this.pageLoading = false
      this.loadPage(true)
    },

    async openMapModal() {
      this.mapLoading = true
      this.mapItems = []
      this.$bvModal.show('subscription_map_modal')

      try {
        const response = await this.$http.post('/reports/bitis-tarihi/map', {
          search_params: this.searchParams,
          search_query: this.searchQuery,
          searchTerm: this.searchQuery
        })
        this.mapItems = response.data.data || []
      } catch (err) {
        void err
        this.mapItems = []
      } finally {
        this.mapLoading = false
      }
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <SubscriptionMapModal :items="mapItems" :loading="mapLoading" />

    <b-modal id="musteri_excel_modal" title="Müşteri Listesi Excel" size="lg" hide-footer>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <span>Kayıtlı raporlar</span>
        <button type="button" class="btn btn-success btn-sm" :disabled="excelCreating" @click="createExcel">
          <i class="fa fa-file-excel"></i> {{ excelCreating ? 'Oluşturuluyor...' : 'Yeni Excel Al' }}
        </button>
      </div>
      <div v-if="excelLoading" class="text-center py-3">Yükleniyor...</div>
      <table v-else class="table table-sm table-hover">
        <thead>
          <tr>
            <th>Tarih</th>
            <th>Dosya</th>
            <th>Alan</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!excelList.length">
            <td colspan="4" class="text-center">Kayıt yok</td>
          </tr>
          <tr v-for="row in excelList" :key="row.id">
            <td>{{ row.created_at }}</td>
            <td>{{ row.filename }}</td>
            <td>{{ row.user_name }} <small v-if="row.source === 'auto'">(otomatik)</small></td>
            <td class="text-end">
              <button type="button" class="btn btn-outline-primary btn-sm" @click="downloadExcel(row)">İndir</button>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>

    <div class="row">
      <div class="col-12">
        <Datatable
              :columns="columns"
              :tableData="tableData"
              @sort-column="handleSortColumn"
              @search-query="reLoadPage"
              @excel-export="excelExport"
              :loading="isLoading"
              :poading="pageLoading">

          <template #toolbar>
            <button class="btn btn-outline-primary" @click="openMapModal">
              <i class="fa fa-map"></i> Haritada Göster
            </button>
          </template>

          <!--<template #filter-province="{ row }">
                <select class="form-select form-select-sm" @change="loadPage()" v-model="searchParams.il">
                  <option value="">İl</option>
                  <option value="" v-for="(bolge,i) in ilList" :key="`il${i}`">1</option>
                </select>
          </template>-->

          <template #searchItems="{ row }">
            <div class="col-lg-12 mt-3">
              <div class="row">
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="mb-3">
                        <label>Müşteri Durumu</label>
                        <select v-model="form.status" class="form-select" @change="handleFilterChange">
                          <option value="">Seçiniz</option>
                          <option value="99">Online Aboneler</option>
                          <option value="1">Aktif</option>
                          <option value="2">Günü Biten</option>
                          <option value="3">İptal</option>
                          <option value="4">Dondurulmuş</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="mb-3">
                        <label>Tarife</label>
                        <select v-model="form.tariff" class="form-select" @change="handleFilterChange">
                          <option value="">Seçiniz</option>
                          <option :value="trf.id" v-for="(trf, i) in tariffList" :key="i">{{ trf.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                        <div class="mb-3">
                          <label>İlçe</label>
                            <v-select
                              label="name"
                              v-model="form.province"
                              :options="ilList"
                              :reduce="country => country.id"
                              @option:selecting="setSelected($event,'bucak')"><span slot="no-options">Sonuç Bulunamadı</span>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="mb-3">
                          <label for="bolge">Bölge</label>
                            <v-select
                              label="name"
                              v-model="form.bolge"
                              :options="bucakList"
                              :reduce="country => country.id"
                              @option:selecting="setSelected($event,'koy')"><span slot="no-options">Sonuç Bulunamadı</span>
                            </v-select>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-xl-12">
                        <div class="row">
                          <div class="col-md-12 mb-3">
                            <label class="d-flex justify-content-between">Üyelik Tarih Aralığı
                              <span
                                v-if="form.startdate || form.startdateend"
                                class="text-danger"
                                @click="form.startdate= '' ;form.startdateend= ''">
                                temizle</span>
                              </label>
                            <div class="input-group">
                              <input type="date" class="form-control"  v-model="form['startdate']"  @change="handleFilterChange">
                              <button style="border:0;background: transparent;">  - </button>
                              <input type="date" class="form-control"  v-model="form['startdateend']"  @change="handleFilterChange">
                            </div>
                          </div>
                        </div>
                      </div>

                  </div>
                  <div class="row">
                    <div class="col-xl-12">
                        <div class="row">
                          <div class="col-md-12 mb-3">
                            <label class="d-flex justify-content-between">Bitiş Tarih Aralığı
                              <span
                                v-if="form.enddate || form.enddateend"
                                class="text-danger"
                                @click="form.enddate= '' ;form.enddateend= ''">
                                temizle</span>
                              </label>
                            <div class="input-group">
                              <input type="date" class="form-control"  v-model="form['enddate']"  @change="handleFilterChange">
                              <button style="border:0;background: transparent;">  - </button>
                              <input type="date" class="form-control"  v-model="form['enddateend']"  @change="handleFilterChange">
                            </div>
                          </div>
                        </div>
                      </div>

                  </div>
                </div>
                <div class="col-xl-4">
                  <div class="row">
                    <div class="col-xl-12">
                        <div class="mb-3">
                          <label for="group">Group</label>
                            <select v-model="form.group" class="form-select"  @change="handleFilterChange">
                              <option value="">Seçiniz</option>
                              <option value="kurumsal">Kurumsal Müşteriler</option>
                              <option :value="group.id" v-for="(group, i) in groupList" :key="`group${i}`">{{ group.name }}</option>
                            </select>
                        </div>
                      </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-12">
                        <div class="mb-3">
                          <label for="bolge">Tarife Tipi</label>
                            <select v-model="form.tarife_group" class="form-select"  @change="handleFilterChange">
                              <option value="">Seçiniz</option>
                              <option value="WIFI">Wireless</option>
                              <option value="ADSL">Adsl</option>
                              <option value="FIBER">Fiber</option>
                            </select>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
        </template>

          <template #created_at="{ row }">
              {{ created_at(row) }}
          </template>
          <template #address="{ row }">
            <span v-b-popover.hover.auto="row.address">{{ row.address }}</span>
          </template>


           <template #changedLabel="{ row }">
              <span v-if="row.status == 2" style="background-color: #0064ff47;">{{ row.fullname }}</span>
              <span v-else-if="row.status == 3" style="background-color: #ffff005e;">{{ row.fullname }}</span>
              <span v-else-if="row.status == 4" style="background-color: #c3c3c39e;">{{ row.fullname }}</span>
              <span v-else-if="row.status == 6" style="background-color: #ffc0cb8c;">{{ row.fullname }}</span>
              <span v-else>{{ row.fullname }}</span>
          </template>


          <template #expiredate="{ row }">
              {{ expiredate(row.expiredate) }}
          </template>

          <template #phonenumber="{ row }">
              <a :href="`tel:${row.phonenumber}`"  >{{row.phonenumber}}</a>
          </template>
          <template #phonenumber2="{ row }">
                <a target="_blank" :href='`https://wa.me/${row.phonenumber2}`' >{{ row.phonenumber2}}</a>
          </template>

          <template #action="{ row }">
              <b-dropdown
                  toggle-class="font-size-16 p-0"
                  toggle-tag="a"
                  variant="white"
                  append-to-body
                  >
                  <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                    <b-dropdown-item @click="yenile(row)">Detaya Git</b-dropdown-item>
              </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>